﻿import { Injectable } from "@angular/core";
import { LocalStorageService } from "angular-2-local-storage";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AuthGuardJubiliService } from "../../../api/jubili/auth-jubili.service";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class AuthGuardJubili implements CanActivate {

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService,
        private authGuardJubiliService: AuthGuardJubiliService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean>  {

        const tempRoute = state.url;
        const userSurrKey = this.localStorageService.get<number>("userSurrKey");
        if (userSurrKey !== undefined) {
          return this.authGuardJubiliService.checkUser(userSurrKey)
            .pipe(
              map(
                response => {
                  if (response) {
                    return true;
                  } else {
                      // set popup show when not have permission
                      this.router.navigate(["/home"]);
                      alert("You don't have permission..");

                      return false;
                  }
                }
              )
            );
        } else {
            this.localStorageService.set("popupshow", "0");
            if (tempRoute === "/home") {
                this.router.navigate(["/home"]);

                return true;
            } else {
                this.router.navigate(["/home"], { queryParams: { tempUrl: tempRoute } });

                return false;
            }

        }
    }
}
